import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, exhaustMap, withLatestFrom, filter, switchMap,takeLast,skipUntil, delay,delayWhen, tap, buffer,bufferWhen, bufferToggle  } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { PowerBIActions } from '../../actions/power-bi/power-bi.actions';
import { PowerBIService } from '@services/power-bi.service';
import { routerRequestActionTo } from '@store/actions/function-actions/router-request.action';

@Injectable()
export class PowerBIEffects {


  loadOnNav$ = createEffect(() => {
    return this.actions$.pipe(
      routerRequestActionTo('/bi', true, true),
      map(() => PowerBIActions.loadPowerBIs())
    );
  });

  getDashboardOnLoad$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PowerBIActions.loadPowerBIs),
      switchMap(() => {
        return this.powerBIService
          .getEmbedToken()
          .pipe(
            map((data) =>
              PowerBIActions.getEmbedDashboardSuccess({ data }),
            ),
            catchError((error) =>
              of(PowerBIActions.getEmbedDashboardFailure({ error }))
            )
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private powerBIService: PowerBIService,
  ) {}
}
